import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Col, Divider, Row } from 'components';
import styles from 'components/common/horizontalTabNav/styles.module.scss';
import { Typography } from 'antd';

const { Text } = Typography;

interface IHorizontalTabNav {
  pathname: string;
  navigationItems: { id: string; label: string; path: string }[];
  useCustomOutlet?: boolean;
}

export const HorizontalTabNav = React.memo((props: IHorizontalTabNav) => {
  const { pathname, navigationItems, useCustomOutlet } = props;
  return (
    <Row gutter={[0, 24]}>
      <Col span={24}>
        <Row className={styles.info_nav} align={'middle'}>
          {navigationItems.map((_navItem, index) => {
            const active = pathname.includes(_navItem.path);
            return (
              <React.Fragment key={_navItem.id}>
                <Row className={styles.nav_item}>
                  <Col span={24}>
                    <Link to={_navItem.path}>
                      <Text style={{ color: active ? '#05796B' : '#525866', fontWeight: active ? 600 : 400 }}>
                        {_navItem.label}
                      </Text>
                    </Link>
                  </Col>
                  {active && <Col className={styles.active_indicator} />}
                </Row>
                {index !== navigationItems.length - 1 && <Divider type={'vertical'} className={styles.divider} />}
              </React.Fragment>
            );
          })}
        </Row>
      </Col>
      {!useCustomOutlet && (
        <Col span={24}>
          <Outlet />
        </Col>
      )}
    </Row>
  );
});
